import { navigateToTeamsApp as navigateToTeamsAppBase } from '@atlaskit/teams-app-config/navigation';
import type {
	NavigationActionPayloadVariants,
	NavigationResult,
} from '@atlaskit/teams-app-config/types';

import { getIsNav4EnabledSafe } from './getIsNav4EnabledSafe';

export const getNavigateToTeamsApp = (
	orgId: string,
	navActionPayload: NavigationActionPayloadVariants,
	shouldOpenInSameTab?: boolean,
): NavigationResult => {
	const isNav4Enabled = getIsNav4EnabledSafe();

	return navigateToTeamsAppBase({
		hostProduct: 'confluence',
		orgId,
		userHasNav4Enabled: isNav4Enabled,
		shouldOpenInSameTab,
		...navActionPayload,
	});
};
